import { render, staticRenderFns } from "./ButtonCompare.vue?vue&type=template&id=2605a59a&"
import script from "./ButtonCompare.vue?vue&type=script&lang=js&"
export * from "./ButtonCompare.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCompare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports